export const soundLinks = {
  Q: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-free-to-use-sounds/ftus_instrument_drum_large_gamelan_hit_single_001_472.mp3",
  W: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-free-to-use-sounds/ftus_instrument_drum_small_gamelan_hit_stick_single_002_478.mp3",
  E: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-14566/zapsplat_musical_cymbal_crash_tap_light_thin_stick_001_17604.mp3",
  A: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-free-to-use-sounds/ftus_musical_instrument_gender_gamelan_single_mallet_hit_mid_low_004_502.mp3",
  S: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-free-to-use-sounds/ftus_musical_instrument_gender_gamelan_single_mallet_hit_high_mid_001_489.mp3",
  D: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-46416/zapsplat_musical_triangle_single_strike_002_48598.mp3",
  Z: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-55112/zapsplat_musical_perscussion_shaker_maracas_kids_single_shake_002_61893.mp3",
  X: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-55112/zapsplat_musical_perscussion_tambourine_kids_set_down_61898.mp3",
  C: "https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-free-to-use-sounds/ftus_musical_instrument_ching_gamelan_single_hit_001_529.mp3"
};

export const instruments = {
  D: "Triangle",
  C: "Finger Cymbals",
  X: "Tambourine",
  Z: "Shaker",
  A: "Gendèr 1",
  Q: "Drum 1",
  W: "Drum 2",
  E: "Crash Cymbal",
  S: "Gendèr 2",
};

export const keys = Object.keys(instruments);

export const PLAY = "PLAY";
export const ENDED = "ENDED";
export const POWER = "POWER"
export const VOLUME_START = "VOLUME_START";
export const VOLUME_END = "VOLUME_END";
export const MUTE = "MUTE"
export const VOLUME_MOVE = "VOLUME_MOVE";